const brandingType = {
    white: 1,
    black: 2
};

export default brandingType;
